import { createElement } from "react";
import type { Sale } from "../types";
import { SalesCreate } from "./SalesCreate";
import { SalesEdit } from "./SalesEdit";
import { SalesList } from "./SalesList";
import { AdminOnlyRoute } from "../misc/AdminOnlyRoute";

const ProtectedSalesList = () =>
  createElement(AdminOnlyRoute, {
    resource: "sales",
    children: createElement(SalesList),
  });

export default {
  list: ProtectedSalesList,
  create: SalesCreate,
  edit: SalesEdit,
  recordRepresentation: (record: Sale) =>
    `${record.first_name} ${record.last_name}`,
};
